import Cookies from 'universal-cookie';
const cookies = new Cookies();

const saveCookie = (name, value, expirationDate) => {
  const date = new Date();
  const expires = expirationDate || new Date(date.setFullYear(date.getFullYear() + 1));
  cookies.set(name, value, {
    expires,
    path: '/'
  });
};

const deleteCookie = name => {
  cookies.remove(name, {
    path: '/'
  });
};

const getCookie = name => cookies.get(name);

export { saveCookie, deleteCookie, getCookie };